import { render, staticRenderFns } from "./UsersAndPermissions.vue?vue&type=template&id=41faa486&"
import script from "./UsersAndPermissions.vue?vue&type=script&lang=js&"
export * from "./UsersAndPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports